import { createModel } from '@rematch/core';

import type {
  IKeyNoteData,
  IQueueTableData,
  TTableName,
} from 'infrastructure/interfaces';
import type { RootModel } from 'store/models';

export type TStoreTableNote = {
  notes: IKeyNoteData[] | null;
  patientGuid?: string;
  patientName?: string;
  tableName?: TTableName;
};
export type TState = {
  tableNote?: TStoreTableNote;
  isOpenDrawer: boolean;
  workQueue: IQueueTableData[];
  updatedNote?: TStoreTableNote | null;
  selectedRows: IQueueTableData[];
};

export const INITIAL_STATE: TState = {
  isOpenDrawer: false,
  workQueue: [],
  selectedRows: [],
};

const ccmConsole = createModel<RootModel>()({
  state: INITIAL_STATE,
  reducers: {
    setTableNote(state, payload: TStoreTableNote) {
      return {
        ...state,
        tableNote: payload,
      };
    },
    updateTableNote(state, payload: { notes: IKeyNoteData[]; guid: string }) {
      const { notes, guid } = payload;
      return {
        ...state,
        tableNote: {
          ...state.tableNote,
          notes,
        },
        workQueue: state.workQueue.map((item) => {
          if (item.guid === guid)
            return {
              ...item,
              notes,
            };

          return item;
        }),
      };
    },
    setUpdatedNote(state, payload: TStoreTableNote | null) {
      return {
        ...state,
        updatedNote: payload,
      };
    },
    toggleOpenDrawer(state) {
      return {
        ...state,
        isOpenDrawer: !state.isOpenDrawer,
      };
    },

    // QUEUE TABLE
    setWorkQueue(state, payload: IQueueTableData[]) {
      return {
        ...state,
        workQueue: payload,
      };
    },
    addToWorkQueue(state, payload: IQueueTableData | IQueueTableData[]) {
      return {
        ...state,
        workQueue: state.workQueue.concat(payload),
      };
    },
    removeFromQueue(state, payload: { guid: string; tableName: TTableName }) {
      return {
        ...state,
        workQueue: state.workQueue.filter(
          (item) =>
            item.guid !== payload.guid || item.tableName !== payload.tableName,
        ),
      };
    },
    clearQueue(state) {
      return {
        ...state,
        workQueue: [],
      };
    },
    updateQueueItem(
      state,
      payload: Partial<IQueueTableData> & { guid: string },
    ) {
      return {
        ...state,
        workQueue: state.workQueue.map((item) => {
          if (item.guid === payload.guid) {
            return {
              ...item,
              ...payload,
            };
          }
          return item;
        }),
      };
    },

    // SELECTED ROWS
    setSelectedRows(state, payload: IQueueTableData[]) {
      return {
        ...state,
        selectedRows: payload,
      };
    },
  },
});

export default ccmConsole;
